module.exports = __webpack_public_path__ + "static/img/slide4_h.4bd3511.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/caroussel/slide4_h.jpeg
// module id = C1zF
// module chunks = 1